import BodyOne from '@/components/portal/ui/typography/BodyOne'
import HeadingTwo from '@/components/portal/ui/typography/HeadingTwo'
import Logo from '@/components/shared/Logo'
import Link from 'next/link'
import React from 'react'

interface RegisterHeaderProps {
  confirmation?: boolean
}

const ForgotPasswordHeader: React.FC<RegisterHeaderProps> = ({
  confirmation,
}) => {
  const copyWithLink = (
    <BodyOne additionalClasses="mb-8" fontSize="text-regular">
      Have an account?{' '}
      <Link href="/login" className="text-green-portal">
        Login
      </Link>
    </BodyOne>
  )

  return (
    <div className="flex flex-col items-center justify-center">
      <HeadingTwo
        fontSize="text-2xl"
        additionalClasses="my-3"
        fontWeight="font-ttHovesBold"
        color="text-green-100"
      >
        {confirmation
          ? 'Check your inbox'
          : 'Provide your email to reset your password'}
      </HeadingTwo>
      {confirmation ? (
        <BodyOne additionalClasses="mb-8" fontSize="text-regular">
          We sent you an authorization code. Please be sure to check your spam
          folder.
        </BodyOne>
      ) : null}
    </div>
  )
}

export default ForgotPasswordHeader
